import { css } from 'styled-components'

export const itemStyles = css`
  .hot-collapse__arrow {
    color: var(--gray-900) !important;
  }
`
